export function useHtmlToText() {
  const isClient = typeof window !== 'undefined'

  const htmlToText = (html: string = ''): string => {
    if (!html || typeof html !== 'string') return ''

    let text = ''

    if (isClient) {
      // DOM extraction on the client
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')
      text = doc.body?.textContent ?? ''
    } else {
      // Basic fallback during SSR
      text = html.replace(/<[^>]*>/g, ' ')
    }

    // Normalize whitespace
    return text.replace(/\s+/g, ' ').trim()
  }

  return {
    htmlToText
  }
}
